<template>
  <section>
    <v-container fluid class="pt-0">
      <v-dialog
        v-model="show_preview"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card tile style="padding-top:75px !important">
          <v-card-title>
            Page Preview
            <v-spacer></v-spacer>
            <v-btn icon @click="show_preview=false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <preview v-model="page"></preview>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card class>
            <v-card-title class="secondary white--text">
              Page
              <v-spacer></v-spacer>
              <v-btn
                fab
                small
                color="success"
                class="mr-4"
                dark
                @click="save"
                v-if="modified && !loading"
              >
                <v-icon>fa-save</v-icon>
              </v-btn>

              <v-btn icon class="mr-4" dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
              <v-btn icon dark to="/admin/content/pages" exact>
                <v-icon>fa-times</v-icon>
              </v-btn>
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="primary"
              ></v-progress-linear>
            </v-card-title>
            <v-container fluid class="admin_secondary white--text">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="page.name"
                    hide-details
                    label="Name"
                    dark
                    placeholder="eg. Promo - 2020"
                    clearable
                    @change="onChange"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="page.slug"
                    hide-details
                    label="Slug"
                    dark
                    placeholder="eg. promo-2020"
                    clearable
                    @change="onChange"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <v-row>
                    <v-col cols="12">
                      <v-switch
                        class="my-0 py-0"
                        v-model="page.published"
                        dark
                        dense
                        single-line
                        hide-details
                        @change="onChange"
                        :false-value="0"
                        :true-value="1"
                        label="Published"
                        color="success"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" class="text-left">
                      <v-btn
                        small
                        @click="show_preview=true"
                        :disabled="!page.sections.length"
                        dark
                        color="primary"
                      >Preview Page</v-btn>
                    </v-col>
                    <v-col cols="12">
                      <v-btn
                        small
                        dark
                        :disabled="!page.published || modified"
                        color="success"
                        :href="`/${page.slug ? page.slug : ''}`"
                        target="_blank"
                      >Published Page</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="text-right py-0"></v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>

            <div style>
              <v-container>
                <v-row align="center">
                  <v-col cols="4"></v-col>
                  <v-col cols="4" class="text-center">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn x-large fab color="primary" small class="mr-4" dark v-on="on">
                          <v-icon>fa-plus</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in available_sections"
                          :key="index"
                          @click="prependSection(item)"
                        >
                          <v-list-item-title>{{ item.type | capitalizeFirstLetter}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <v-menu offset-y v-if="page.sections.length>1">
                      <template v-slot:activator="{ on }">
                        <v-btn x-large text color="secondary" small dark v-on="on">
                          Sections
                          <v-icon class="ml-2">fa-ellipsis-v</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="$eventBus.$emit('pages-expand-all')">
                          <v-list-item-title>Expand All</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$eventBus.$emit('pages-minimize-all')">
                          <v-list-item-title>Minimize All</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$eventBus.$emit('pages-preview-all')">
                          <v-list-item-title>Preview All</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$eventBus.$emit('pages-edit-all')">
                          <v-list-item-title>Edit All</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteAllSections">
                          <v-list-item-title class="error--text">Delete All</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
              <draggable v-model="page.sections" @update="onChange" handle=".draggable">
                <div v-for="(section,s) in page.sections" :key="s">
                  <edit-header
                    v-if="section.type==='header'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-header>
                  <edit-about
                    v-if="section.type==='about'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-about>
                  <edit-features
                    v-if="section.type==='features'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-features>
                  <edit-services
                    v-if="section.type==='services'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-services>
                  <edit-previews
                    v-if="section.type==='previews'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-previews>
                  <edit-video
                    v-if="section.type==='video'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-video>
                  <edit-divider
                    v-if="section.type==='divider'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-divider>

                  <edit-pricing
                    v-if="section.type==='pricing'"
                    v-model="section.data"
                    @change="onChange"
                    @duplicate="duplicateSection(section)"
                    @delete="deleteSection(section)"
                  ></edit-pricing>
                </div>
              </draggable>
              <v-container v-if="page.sections.length">
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn x-large fab color="primary" small class="mr-4" dark v-on="on">
                          <v-icon>fa-plus</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in available_sections"
                          :key="index"
                          @click="appendSection(item)"
                        >
                          <v-list-item-title>{{ item.type | capitalizeFirstLetter}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import preview from "@/components/page";

import sections from "@/assets/sections.json";

import EditAbout from "@/components/page/About/edit";
import EditHeader from "@/components/page/Header/edit";
import EditVideo from "@/components/page/Video/edit";
import EditFeatures from "@/components/page/Features/edit";
import EditServices from "@/components/page/Services/edit";
import EditPreviews from "@/components/page/Previews/edit";
import EditDivider from "@/components/page/Divider/edit";
import EditPricing from "@/components/page/Pricing/edit";

import draggable from "vuedraggable";

export default {
  name: "AdminContentPage",
  components: {
    preview,
    draggable,
    EditHeader,
    EditAbout,
    EditFeatures,
    EditServices,
    EditPreviews,
    EditVideo,
    EditDivider,
    EditPricing
  },
  data() {
    return {
      loading: false,
      show_preview: false,
      modified: false,
      available_sections: sections,
      page: {
        slug: "",
        sections: []
      }
    };
  },
  mounted() {
    this.load();
  },
  computed: {},
  async beforeRouteLeave(to, from, next) {
    if (
      this.modified &&
      !confirm("Do you really want to leave? you have unsaved changes!")
    ) {
      return;
    } else {
      next();
    }
  },
  methods: {
    deleteAllSections() {
      if (!confirm("Delete all sections ?")) {
        return;
      }
      this.page.sections = [];
      this.onChange();
    },
    duplicateSection(section) {
      this.page.sections.splice(this.page.sections.indexOf(section) + 1, 0, {
        ...section
      });

      this.onChange();
    },
    deleteSection(section) {
      if (!confirm("Delete section ?")) {
        return;
      }
      this.page.sections = this.page.sections.filter(s => {
        return s !== section;
      });
      this.onChange();
    },
    appendSection(item) {
      this.page.sections.push(item);
      this.onChange();
    },
    prependSection(item) {
      this.page.sections.unshift(item);
      this.onChange();
    },
    onChange() {
      this.modified = true;
    },
    async load() {
      this.loading = true;
      try {
        this.page = await this.$api(`/admin/pages/${this.$route.params.id}`);
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;
      try {
        this.page = await this.$api.patch(
          `/admin/pages/${this.$route.params.id}`,
          this.page
        );
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>